import { render } from "./AlignVerticalBottom.vue?vue&type=template&id=c319ac4c"
import script from "./AlignVerticalBottom.vue?vue&type=script&lang=js"
export * from "./AlignVerticalBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlignVerticalBottom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c319ac4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c319ac4c', __exports__)) {
    api.reload('c319ac4c', __exports__)
  }
  
  module.hot.accept("./AlignVerticalBottom.vue?vue&type=template&id=c319ac4c", () => {
    api.rerender('c319ac4c', render)
  })

}


export default __exports__